import React, { useState } from 'react';
import { Button, FormInput, InputGroup, InputGroupAddon, InputGroupText, Row, ListGroup, FormRadio, ListGroupItem } from 'shards-react';
import withScrollInToView from '../../withScrollInToView';
import { connect } from 'react-redux';
import { reorderThumbnails } from '../../../utils/redux/actions';

const NewColumnForm = ({ dispatch, thumbnails, closeModal, docTypesList }) => {
	const [typesList, setTypesList] = useState(docTypesList);
	const [checkedType, setCheckedType] = useState(false);

	const addNewTypeColumn = () => {
		if (thumbnails.columns[checkedType.shortName] === undefined) {
			const thumbnailsWithNewColumn = {
				...thumbnails,
				columnOrder: [...thumbnails.columnOrder, checkedType.shortName],
				columns: {
					...thumbnails.columns,
					[checkedType.shortName]: {
						id: checkedType.shortName,
						pageIds: [],
						shortName: checkedType.shortName,
						title: checkedType.displayName,
						typesIncluded: checkedType.typesIncluded,
					},
				},
			};

			dispatch(reorderThumbnails(thumbnailsWithNewColumn));
		}
		return closeModal();
	};

	return (
		<>
			<InputGroup seamless>
				<InputGroupAddon type='prepend'>
					<InputGroupText>
						<i className='fas fa-search' />
					</InputGroupText>
				</InputGroupAddon>
				<FormInput
					autoFocus
					type='search'
					className='mb-2 w-auto'
					placeholder='Bitte tragen Sie einen neuen Typ ein.'
					onChange={({ target: { value } }) => {
						if (!docTypesList) return;
						setCheckedType(false);
						setTypesList(docTypesList.filter(({ displayName }) => displayName.toLowerCase().includes(value.toLowerCase())));
					}}
				/>
			</InputGroup>
			<Row className='h-auto overflow-auto mt-1' noGutters style={{ maxHeight: '250px' }}>
				<ListGroup className='pb-1 flex-grow-1'>
					{(!typesList || typesList.length < 1) && <ListGroupItem className='pointer text-center p-2 text-danger'>Keine Ergebnisse</ListGroupItem>}
					{typesList?.map((type, index) => (
						<ListGroupItem key={index} className={`px-2 pt-2 pb-0 pointer${index % 2 ? ' bg-light' : ''}`}>
							<FormRadio checked={type.displayName === checkedType.displayName} onChange={() => setCheckedType(type)} children={type.displayName} />
						</ListGroupItem>
					))}
				</ListGroup>
			</Row>
			<Row noGutters className='justify-content-center mt-1'>				
				{checkedType ? 
					(
						<>
							<Button className='mr-auto' pill theme='danger' onClick={closeModal}>
								Abbrechen
							</Button>
							<Button pill theme='success' onClick={addNewTypeColumn}>
								Hinzufügen
							</Button>
						</>						
					) :
					(
						<Button pill theme='danger' onClick={closeModal}>
							Abbrechen
						</Button>
					)
				}				
			</Row>
		</>
	);
};

const mapStateToProps = ({ savedDocument: { thumbnails }, docTypesList }) => ({ thumbnails, docTypesList });

export default connect(mapStateToProps)(withScrollInToView(NewColumnForm)); //Export component and connect it with redux.
